require("prismjs/themes/prism.css");

exports.onClientEntry = () => {
    require("prismjs/plugins/line-numbers/prism-line-numbers.css");
}

// 部落格的分類篩選只改 query string（navigate replace）。Gatsby 預設每次換網址都捲回頂端，
// 手機上往下滑一點再切分類，畫面會整個跳走。只有 query string 變時維持原位；
// hash 有變的不攔，文章頁目錄的錨點跳轉要照常捲動
exports.shouldUpdateScroll = ({ prevRouterProps, routerProps: { location } }) => {
    const prev = prevRouterProps?.location;
    const onlySearchChanged = prev
        && prev.pathname === location.pathname
        && prev.hash === location.hash
        && prev.search !== location.search;
    return !onlySearchChanged;
}